// @flow

import React, { type ComponentType, type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks/use-unique-id';
import { InputText } from '../atom/input-text';
import { Label } from '../atom/label';

export function InputField(props: InputFieldProps): Node {
  const id = useUniqueId();
  const { fieldProps, error, label, onChange, placeholder, value, ...rest } = props;
  const Input = props.input || InputText;

  return (
    <div {...fieldProps}>
      <div style={{ marginBottom: '0.2em' }}>
        <Label htmlFor={id}>{label}</Label>
      </div>
      <div>
        <Input
          {...rest}
          id={id}
          style={{ width: '100%', display: 'block' }}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          kind={error ? 'error' : undefined}
        />
      </div>
      {error && (
        <div>
          <Label bold size="small" kind="error">{error}</Label>
        </div>
      )}
    </div>
  );
}

type InputFieldProps = {
  fieldProps?: {},
  label: string,
  placeholder?: string,
  value?: string,
  onChange?: (SyntheticInputEvent<InputText>) => void,
  error?: ?string,
  input?: ComponentType<InputProps>,
};

type InputProps = {
  placeholder?: string,
  value?: string,
  onChange?: (SyntheticInputEvent<InputText>) => void,
};
